import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import 'rxjs/add/observable/of';
import { switchMap, first } from "rxjs/operators";
import 'rxjs/add/operator/toPromise';

//Firebase
import { AngularFireAuth } from "angularfire2/auth";
import { AngularFirestore, AngularFirestoreDocument } from "angularfire2/firestore";
import * as firebase from "firebase/app"

//Variables
import { environment } from '@env/environment';
import { StorageService } from '@app/core/services/storage.service';

export interface Param{
  uid: string,
  name: string,
  description: string,
  value: string,
}

@Injectable()
export class GlobalParamService {
  //isLoggedIn: boolean = false;


  constructor(private afAuth: AngularFireAuth,
    private afs: AngularFirestore){
      
  }

  public async getParamValueAsString(paramName:string){
    let data2=await this.afs.collection('parameters-global', (ref) =>
      ref.where('name', '==', paramName)
    ).valueChanges().pipe(first()).toPromise();


    if(data2){
      let param:any =data2[0];
      if(param)
        return param.value;
    }
  
    return null;
  }
}
